import { Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { useEffect, useState } from "react";
import { getFields } from "../../../../api/ContactAPI";
import { useLanguage } from "../../../../stores/LanguageStore";
import {
  createLinkedinMessage,
  getLinkedinMessages,
} from "../../../../api/ModelsApi";
import { notifications } from "@mantine/notifications";
import { IconFileImport, IconMicrophoneFilled } from "@tabler/icons-react";
import SmvEditor from "../smv/SmvEditor";

const CreateModelLinkedinVoice = ({ handleClose, onCreated }) => {
  const lang = useLanguage((s) => s.language);
  const [file, setFile] = useState(null);

  useEffect(() => {
    getFields();
  }, []);

  return (
    <Group p={"xl"} px={0} wrap="nowrap" align="stretch">
      <SmvEditor
        setFile={setFile}
        inFile
        opener={({ handleOpen }) => (
          <Paper
            component={Stack}
            withBorder
            p={"lg"}
            py={64}
            w={"50%"}
            align="center"
            style={{ borderColor: "var(--mantine-color-primary-6)" }}
            className="workflow-start-type"
            onClick={handleOpen}
          >
            <ThemeIcon color="primary" size={64}>
              <IconMicrophoneFilled size={64} />
            </ThemeIcon>
            <Text size="lg" ta={"center"}>
              Enregistrez votre message <br /> vocal maintenant
            </Text>
          </Paper>
        )}
      />
      <Paper
        component={Stack}
        withBorder
        p={"lg"}
        py={64}
        w={"50%"}
        align="center"
        style={{ borderColor: "var(--mantine-color-primary-6)" }}
        justify="center"
        className="workflow-start-type"
      >
        <ThemeIcon color="primary" size={64}>
          <IconFileImport size={64} />
        </ThemeIcon>
        <Text size="lg" ta={"center"}>
          Importez un fichier MP3
        </Text>
      </Paper>
    </Group>
  );
};

export default CreateModelLinkedinVoice;
